export default {
  Prevention: 'rgb(255, 8, 194)',
  'Human Challenge Trial': 'rgb(68, 68, 68)',
  'Safety and Immunogenicity': 'rgb(24, 191, 255)',
}
